// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__12EoO","list":"FieldCheckboxGroup_list__2RbVZ","twoColumns":"FieldCheckboxGroup_twoColumns__RnbnN","item":"FieldCheckboxGroup_item__3kAGq"};